import React from 'react';
import { View, Text } from 'react-native';
import LedgerLine from './LedgerLine';
import styles from '../styles';

export type Ledger = {
  ChargeAmount: string;
  ChargeCode: string;
  Description: string;
  Notes: string;
  TransDate: string;
  TransID: string;
  TransType: string;
  isOpen: string;
  isPosted: string;
};

const LedgerItem = ({ item, isBrown }: any) => {
  return (
    <View
      style={[
        styles.ledgerItem,
        isBrown ? styles.backgroundBrown : styles.backgroundPlain,
      ]}
    >
      <View style={styles.headerLedgerItem}>
        <LedgerLine
          customStyle={styles.ledgerTitleCustomStyle}
          title="Date"
          label={item.TransDate}
        />
        <LedgerLine
          customStyle={styles.ledgerlabelCustomStyle}
          title="ID"
          label={item.TransID}
        />
      </View>
      <LedgerLine isLimitWidth title="Description" label={item.Description} />
      <LedgerLine isLimitWidth title="Notes" label={item.Notes} />
      <View style={styles.footerLedgerItem}>
        <LedgerLine
          customStyle={styles.ledgerTitleCustomStyle}
          isLimitWidth
          title="Amout"
          label={item.ChargeAmount}
        />
        <LedgerLine
          customStyle={styles.ledgerlabelCustomStyle}
          title="Type"
          label={item.TransType}
        />
      </View>
    </View>
  );
};

export default React.memo(LedgerItem);
